// extracted by mini-css-extract-plugin
export default {"itmCont":"LogerItem_itmCont__R9VWI","mainCont":"LogerItem_mainCont__FOI6u","title":"LogerItem_title__22Ng-"};